import { userApi } from './api';

const fetchLoggedUser = async () => {
  try {
    const response = await userApi.get('me/')
    return response.data
  } catch (error) {
    console.error('Error fetching logged user:', error)
    throw error
  }
}

const logout = async () => {
  const csrfToken = localStorage.getItem('csrfToken');
  await userApi.post('logout/', {}, {
    headers: { 'X-CSRFToken': csrfToken },
  });
}

export {
  fetchLoggedUser,
  logout,
};